import { JourneyAlias } from '@hc-frontend/core-types';
import { getSafeURLParameters } from '@hc-frontend/core-utils-dom';

export function getJourneyOverrideFromLandingUrl(
  landingUrl: string,
): JourneyAlias | null {
  if (landingUrl && landingUrl.trim().length > 0) {
    const urlParameters = getSafeURLParameters(landingUrl);
    if ('journeyOverride' in urlParameters) {
      const journeyOverride = JourneyAlias.safeParse(
        urlParameters['journeyOverride'],
      );
      if (journeyOverride.success) {
        return journeyOverride.data;
      }
    }
  }

  return null;
}
